import { LabeledSelectBox } from '@components/labeledSelectBox';
import { useCallback, useRef } from 'react';
import { useFragment } from 'react-relay';
import { useNavigate } from 'react-router-dom';
import { trancheSelectionFragment } from './TrancheSelection.relay';
import type { TrancheSelectionProps } from './types';

export const TrancheSelection: React.FC<TrancheSelectionProps> = ({ component, path, location }) => {
  const navigate = useNavigate();
  const trancheSelectorRef = useRef<HTMLDivElement>(null);
  const data = useFragment(trancheSelectionFragment, component);

  const onChange = useCallback(
    (key: string) => {
      navigate(key, { state: location?.state });
    },
    [navigate, location],
  );

  const sortTranches = useCallback(
    (a: any, b: any) => {
      return a.key === path.substr(1) ? -1 : 1;
    },
    [path],
  );

  const filterTranches = useCallback(
    (tranche: any) => {
      if (typeof location === 'string') {
        return true;
      }
      return tranche.data.indexOf(location.state.salesAdmission) > -1;
    },
    [location],
  );

  const isSingleIsin = data.tranches?.trancheSelectBox?.options?.length ? data.tranches.trancheSelectBox.options.length < 2 : true;

  return (
    <div ref={trancheSelectorRef} className="py-4">
      {!isSingleIsin && data.tranches && <LabeledSelectBox labeledSelectBox={data.tranches} selected={path} onChange={onChange} width="220px" sort={sortTranches} filter={filterTranches} />}
    </div>
  );
};
